import { render, staticRenderFns } from "./TypeSectorForm.vue?vue&type=template&id=3917922c&"
import script from "./TypeSectorForm.vue?vue&type=script&lang=js&"
export * from "./TypeSectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports